"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.runToposort = runToposort;
const toposort_1 = __importDefault(require("toposort"));
const errors_1 = require("../errors");
const TOPO_SORT_ERROR_MESSAGE = "Cyclic dependency, node was:";
function runToposort(edges) {
    try {
        return (0, toposort_1.default)(edges);
    }
    catch (ex) {
        if (ex instanceof Error && ex.message.startsWith(TOPO_SORT_ERROR_MESSAGE)) {
            let node;
            try {
                node = JSON.parse(ex.message.slice(TOPO_SORT_ERROR_MESSAGE.length));
            }
            catch (ex2) {
                throw ex;
            }
            throw new errors_1.CyclicalDependencyError(ex.message, node.name || node.type || "", node.termName, node.iterableName);
        }
        throw ex;
    }
}
//# sourceMappingURL=run-toposort.js.map